import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import {
    AppearanceModuleSideListOptions,
    IAppearanceModuleSideListOption,
} from '../../apeparance-module-side-list-options';
import { ModuleType } from '@fi-shared/types/module-type';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { EditTabsModel } from '@fi-app/utilities/edit-tabs/edit-tabs.model';
import { AppTextService } from '@fi-shared/app-text';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { WidgetContentModel } from '@fi-app/widget/model/widget-content.model';
import { WidgetModel } from '@fi-app/widget/model/widget.model';

@Component({
    selector: 'fi-appearance-sidebar-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-appearance-sidebar-view' },
    standalone: false,
})
export class FiAppearanceSidebarViewComponent implements OnInit {
    @Input() appearanceSidebarStateModel: { modulePreviewTemplateName: string };
    @Input('widgets') Widgets: WidgetModel[];

    sideListOptions: IAppearanceModuleSideListOption[] = [];
    selectedSideListOption: IAppearanceModuleSideListOption;
    ObjectTypes = ObjectTypes;
    ModuleType = ModuleType;
    editTabs: EditTabsModel;

    constructor(
        private contentLanguagesService: ContentLanguagesService,
        private detectDevice: DetectDevicesService,
        private appTextService: AppTextService,
        private stateService: FiStateService,
    ) {}

    ngOnInit() {
        this.setInitialComponentData();
    }

    private setInitialComponentData() {
        this.editTabs = new EditTabsModel(
            this.appTextService.get('appearance.sidebar_header'),
            undefined,
            this.appTextService.get('common.edit'),
        );

        this.sideListOptions = AppearanceModuleSideListOptions.filter((item: IAppearanceModuleSideListOption) => {
            return item.moduleType !== ModuleType.Core;
        });

        this.selectedSideListOption = this.sideListOptions.find(
            (item: IAppearanceModuleSideListOption) =>
                item.previewTemplateName === this.appearanceSidebarStateModel.modulePreviewTemplateName,
        );

        this.Widgets.forEach((widget: WidgetModel) => {
            widget.WidgetModuleContentCollection.forEach((content: WidgetContentModel) => {
                content.InitializeWidgetContentLanguageLabels(this.contentLanguagesService.GetContentLanguages());
            });
        });
    }

    editSidebar() {
        this.stateService.go(FiStateNames.Appearance.Sidebar.Edit);
    }

    selectSideListOption(sideListOption: IAppearanceModuleSideListOption) {
        this.appearanceSidebarStateModel.modulePreviewTemplateName = sideListOption.previewTemplateName;
        this.selectedSideListOption = sideListOption;
    }

    isSideListOptionSelected(sideListOption: IAppearanceModuleSideListOption): boolean {
        return sideListOption.moduleType === this.selectedSideListOption.moduleType;
    }

    get showAppearanceEdit(): boolean {
        return !this.detectDevice.isMobilePhone();
    }
}
